<template>
    <div>
        <div class="form__group form__group--checkbox" >
					    <label>
					        <input  type="checkbox" 
									name="accept_tos" 
									value="1" 
									autocomplete="off" 
									class="js-toggle-tos" 
									v-model="checked"
									>
					        <div class="form__icon"></div>
					        <div class="form__label">
					            Съгласен съм с&nbsp;<a v-bind:href="link" target="_blank" >Общи условия за ползване</a>
					        </div>
					    </label>
					</div>

					<input type="hidden" name="_token" v-bind:value="tokenValue">

					<button v-bind:disabled="isDisabled" class="btn btn--secondary js-btn-order">
						Поръчай
					</button>
    </div>
</template>

<script>

export default {
	props: {
		toslink: {
			type: String,
			required: true
		},

		token: {
			type: String,
			required: true
		}
	},

    data() {
        return {
		   link: this.toslink,
		   checked: false,
		   tokenValue: this.token,
		   isBnpChecked: false,
		   isDskChecked: false,
		   isCreditCheck: false,
		   isPersonalDataCheck: false,
        }
	},

	computed: {
		isDisabled: function() {
			return this.isBnpChecked || this.isDskChecked ? !(this.areTwoChecksChecked && this.checked) : !this.checked;
		},

		areTwoChecksChecked: function() {
			return (this.isCreditCheck && this.isPersonalDataCheck);
		}
	},

	created() {
		this.$eventBus.$on('check-selected-company', (data, data1, data2) => {
			this.isCreditCheck = data1;
			this.isPersonalDataCheck = data2;

			this.isBnpChecked = data === 'bnp';
			this.isDskChecked = data === 'dsk';
			 
		});

		this.$eventBus.$on('checked-credit-conditions', data => {
			this.isCreditCheck = data;
		});

		this.$eventBus.$on('checked-peronal-data', data => {
			this.isPersonalDataCheck = data;
		});
	},
}
</script>